import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { MessageSquare } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { CrmTabs } from "@/features/crm/crm-tabs";
import { TemplatesView } from "@/features/crm/templates-view";

function CrmTemplatesPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="6xl">
      <PageHeader
        title={t(msg`WhatsApp templates`)}
        description={t(msg`Reusable message templates`)}
        icon={MessageSquare}
        backTo="/crm"
      />
      <div class="mt-4">
        <CrmTabs />
        <TemplatesView />
      </div>
    </PageContainer>
  );
}

export const crmTemplatesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/crm/templates",
  component: withFeatureGate("crm.leads", CrmTemplatesPage),
});
